import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { ILOGPRE } from '@/types/base.d';
import { IPackage } from '@/types/org.d';
import api from '@/api/org';

@Component
export default class formMixin extends Vue {
  @State(state => state.org.curComp) curComp!: string;

  @Mutation('org/SET_ORG_BTN_COMPENT') setCurComp!: Function;

  @Mutation('org/SET_ORG_COMPENT_REFRESH') handleRerfesh!: Function;

  public log: ILOGPRE = {
    name: '机构管理 - 充值 - 模态框 -',
    component: 'org/manage/components/bModal',
  };

  public form: IPackage = {
    orgPid: '',
    coursePid: '',
    price: 500,
    remark: '',
  };

  private loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  public coursePackages: { label: string, value: number }[] = [];

  private rules: any = {
    coursePid: [
      { required: true, message: '课包不能为空' },
    ]
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author Terry
   * @description 提交Form 完成后执行此方法
   */
  submitFinish() {
    this.reset(true, true);
    this.loading = false;
    if (this.curComp !== 'Course') this.setCurComp('Course');
    else this.handleRerfesh(true);
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑课包分配
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        if (title.includes('编辑')) {
          const data = Object.assign({}, this.form);
          delete data.courseTitle;
          delete data.pid;
          api.editPackage(data).then(() => {
            this.submitFinish();
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.alloctPackage(this.form).then(() => {
            this.submitFinish();
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
